import { PopUpVariant } from "interfaces";
import { Fragment } from "react";
import {
	AppUpdateAvailable,
	BouncyChestReward,
	BundleUp,
	BundleUpInfo,
	CGGClubHopper,
	CGGEarnedReward,
	CGGEligibilityTools,
	CGGEventCompleted,
	CGGMoreInfo,
	CGGNewTier,
	CGGNotEnoughClubMembers,
	CGGNotYetContributed,
	CGGPurchaseSuccess,
	DailyRewardEarned,
	DailyRewardLoyaltyPoints,
	DailyRewardStreakBreak,
	DripOffer,
	DripOfferEnd,
	DripOfferInfo,
	DripOfferMissedEvent,
	DripOfferReward,
	EndlessOfferReward,
	GrantRewardCollected,
	LoyaltyPointsAdded,
	LoyaltyPointsInfo,
	PBFTUEV2,
	PBFTUEV3,
	PBLearnMore,
	PBRewardCollected,
	PBV3ClubChange,
	PBV3CycleComplete,
	PBV3RewardsCollected,
	PBV3SelectEvent,
	PBV3TierComplete,
	PWARewardPopup,
	PWAInfoPopup,
	RebateMainPopup,
	RewardingDeeplinks,
	SignUpIncentiveReward,
	SingleItemInfo,
	Tutorial,
	TutorialV2,
	TutorialLoyaltyShop,
	TutorialLoyaltyShopV2,
	PushInfoPopup,
	PushPermissionsPopup,
	FriendShopConfirmPopup,
	FriendShopCollectPopup,
	FriendShopInfoPopup,
	FriendInviteConfirmPopup,
	FriendInviteSuccessClaimPopup,
	FriendInviteAcceptedOrErrorPopup,
	FirstPurchase
} from "./lib";

export const variantLoader = (variant: PopUpVariant): JSX.Element => {
	const index = variant.split("::").slice(-1)[0];

	if (variant.includes("single-item-info::")) {
		return <SingleItemInfo />;
	}
	if (variant.includes("cgg-purchase-success::")) {
		return <CGGPurchaseSuccess tierIndex={Number(index)} />;
	}
	switch (variant) {
		case "grant-reward-collected":
			return <GrantRewardCollected />;
		case "pb-learn-more":
			return <PBLearnMore />;
		case "pb-reward-collected-v3":
			return <PBRewardCollected />;
		case "pb-pbftue-v2":
			return <PBFTUEV2 />;
		case "pb-pbftue-v3":
			return <PBFTUEV3 />;
		case "pb-v3-rewards-uncollected":
			return <PBV3RewardsCollected />;
		case "pb-v3-select-event":
			return <PBV3SelectEvent />;
		case "pb-v3-tier-complete":
			return <PBV3TierComplete />;
		case "pb-v3-cycle-complete":
			return <PBV3CycleComplete />;
		case `pb-v3-club-change::${index}`:
			return <PBV3ClubChange isNewClub={!!Number(index)} />;
		case "loyalty-points-added":
			return <LoyaltyPointsAdded />;
		case "cgg-club-hopper":
			return <CGGClubHopper />;
		case "cgg-more-info":
			return <CGGMoreInfo />;
		case "cgg-earned-reward":
			return <CGGEarnedReward />;
		case "cgg-eligibility-tools":
			return <CGGEligibilityTools />;
		case "cgg-event-completed":
			return <CGGEventCompleted />;
		case "cgg-new-tier":
			return <CGGNewTier />;
		case "cgg-not-enough-club-members":
			return <CGGNotEnoughClubMembers />;
		case "cgg-not-yet-contributed":
			return <CGGNotYetContributed />;
		case "daily-login-earned-reward":
			return <DailyRewardEarned />;
		case "daily-login-streak-break":
			return <DailyRewardStreakBreak />;
		case "daily-login-streak-loyalty-points":
			return <DailyRewardLoyaltyPoints />;
		case "endless-offer-reward-collected":
			return <EndlessOfferReward />;
		case "drip-offer":
			return <DripOffer />;
		case `drip-offer-info::${index}`:
			return <DripOfferInfo index={Number(index)} />;
		case "drip-offer-reward":
			return <DripOfferReward />;
		case "drip-offer-missed-event":
			return <DripOfferMissedEvent />;
		case "drip-offer-end":
			return <DripOfferEnd />;
		case "bouncy-chest-reward-collected":
			return <BouncyChestReward />;
		case "tutorial":
			return <Tutorial />;
		case "tutorial-loyalty-shop":
			return <TutorialLoyaltyShop />;
		case "tutorial-v2":
			return <TutorialV2 />;
		case "tutorial-loyalty-shop-v2":
			return <TutorialLoyaltyShopV2 />;
		case "loyalty-points-info":
			return <LoyaltyPointsInfo />;
		case "sign-up-incentive-reward":
			return <SignUpIncentiveReward />;
		case "rewarding-deeplink-reward":
			return <RewardingDeeplinks />;
		case `bundle-up::${index}`:
			return <BundleUp id={index} />;
		case `bundle-up-info::${index}`:
			return <BundleUpInfo id={index} />;
		case `rebate-main-popup::${index}`:
			return <RebateMainPopup id={index} />;
		case "pwa-reward-popup":
			return <PWARewardPopup />;
		case "pwa-info-popup":
			return <PWAInfoPopup />;
		case "push-permissions-popup":
			return <PushPermissionsPopup />;
		case "push-info-popup":
			return <PushInfoPopup />;
		case "friend-shop-confirm-popup":
			return <FriendShopConfirmPopup />;
		case "friend-shop-collect-popup":
			return <FriendShopCollectPopup />;
		case "friend-shop-info-popup":
			return <FriendShopInfoPopup />;
		case "friend-invite-confirm-popup":
			return <FriendInviteConfirmPopup />;
		case "friend-invite-success-claim-popup":
			return <FriendInviteSuccessClaimPopup />;
		case "friend-invite-accepted-popup":
			return <FriendInviteAcceptedOrErrorPopup />;
		case "app-update-available":
			return <AppUpdateAvailable />;
		case "first-purchase":
			return <FirstPurchase />;
		default:
			return <Fragment />;
	}
};
